import React, { useCallback, useEffect, useRef, useState } from "react";
import { axiosRequest } from "../../utility/axios";
import { getChipColor } from "../../components/ChipToken";

const API_URL = process.env.REACT_APP_API_URL;
const AUTH_KEY = "dealer_tip_auth";

const CSS = `
*,*::before,*::after{box-sizing:border-box;}
.dt-root{min-height:100vh;min-height:100dvh;background:#0f1115;color:#f2f2f2;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;padding-bottom:40px;}
.dt-header{position:sticky;top:0;z-index:20;background:#161922;border-bottom:1px solid #262a36;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;}
.dt-header h1{font-size:17px;font-weight:700;letter-spacing:.3px;margin:0;}
.dt-logout{background:none;border:1px solid #333846;color:#c9cdd6;font-size:12px;padding:6px 10px;border-radius:8px;}
.dt-body{padding:16px;max-width:640px;margin:0 auto;}
.dt-card{background:#1a1d27;border:1px solid #262a36;border-radius:14px;padding:16px;margin-bottom:14px;}
.dt-field{margin-bottom:14px;}
.dt-field label{display:block;font-size:12.5px;color:#a6abb6;margin-bottom:6px;font-weight:600;}
.dt-input,.dt-select{width:100%;padding:13px 12px;border-radius:10px;border:1px solid #333846;background:#12141b;color:#f2f2f2;font-size:16px;-webkit-appearance:none;appearance:none;}
.dt-input:focus,.dt-select:focus{outline:none;border-color:#4fd1c5;}
.dt-chip-row{display:grid;grid-template-columns:56px 1fr 1fr;gap:10px;align-items:center;margin-bottom:10px;}
.dt-chip-badge{display:flex;align-items:center;justify-content:center;height:40px;border-radius:8px;font-weight:700;font-size:13px;}
.dt-amount{display:flex;align-items:center;justify-content:flex-end;padding-right:4px;font-weight:700;color:#7be0a0;font-size:14px;}
.dt-total{background:linear-gradient(135deg,#11998e,#38ef7d);color:#08201d;border-radius:12px;padding:14px 16px;font-weight:800;font-size:16px;text-align:center;margin-bottom:14px;}
.dt-total.zero{background:#1a1d27;color:#7d818c;border:1px solid #262a36;}
.dt-btn{width:100%;padding:14px;border-radius:12px;border:none;font-size:15.5px;font-weight:700;cursor:pointer;}
.dt-btn-primary{background:#4fd1c5;color:#08201d;}
.dt-btn-primary:disabled{opacity:.5;}
.dt-toast{position:fixed;left:50%;bottom:20px;transform:translateX(-50%);background:#262a36;color:#fff;padding:11px 18px;border-radius:10px;font-size:13.5px;z-index:100;box-shadow:0 8px 24px rgba(0,0,0,.4);max-width:90vw;text-align:center;}
.dt-toast.err{background:#4a1c22;color:#ffb3b3;}
.dt-login-wrap{min-height:100vh;min-height:100dvh;display:flex;align-items:center;justify-content:center;background:#0f1115;padding:20px;}
.dt-login-card{background:#1a1d27;border:1px solid #262a36;border-radius:18px;padding:28px 22px;width:100%;max-width:360px;}
.dt-login-card h1{text-align:center;font-size:19px;margin:0 0 4px;}
.dt-login-card p{text-align:center;color:#9aa0ac;font-size:12.5px;margin:0 0 22px;}
.dt-login-err{color:#ff8a8a;font-size:12.5px;text-align:center;margin-top:10px;}
.dt-section-title{font-size:12.5px;font-weight:700;color:#8b8f99;text-transform:uppercase;letter-spacing:.4px;margin:6px 0 8px;}
.dt-decl-row{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#1a1d27;border:1px solid #262a36;border-radius:12px;padding:11px 14px;margin-bottom:8px;}
.dt-decl-info{flex:1;}
.dt-decl-name{font-weight:700;font-size:14px;}
.dt-decl-sub{font-size:11.5px;color:#9aa0ac;margin-top:2px;}
.dt-status{font-size:11px;font-weight:800;padding:3px 9px;border-radius:100px;white-space:nowrap;}
.dt-status-pending{background:#20364f;color:#7ec8ff;}
.dt-status-matched{background:#1f3a2c;color:#7be0a0;}
.dt-status-mismatched{background:#3a1a1f;color:#ff8a8a;}
.dt-empty{text-align:center;color:#7d818c;padding:20px 10px;font-size:13px;}
.dt-suggest{position:relative;}
.dt-suggest-list{position:absolute;left:0;right:0;top:calc(100% + 4px);background:#1f232f;border:1px solid #333846;border-radius:10px;max-height:260px;overflow-y:auto;z-index:30;}
.dt-suggest-item{padding:12px 14px;font-size:14.5px;font-weight:600;border-bottom:1px solid #262a36;}
.dt-suggest-item:last-child{border-bottom:none;}
.dt-suggest-sub{font-size:11.5px;color:#9aa0ac;font-weight:400;margin-left:6px;}
.dt-selected-name{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#12141b;border:1px solid #4fd1c5;border-radius:10px;padding:13px 12px;}
.dt-selected-name button{background:none;border:none;color:#9aa0ac;font-size:12px;font-weight:700;text-decoration:underline;}
`;

const fmtTime = (d) => (d ? new Date(d).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "--");

const STATUS_LABEL = { PENDING: "Pending", MATCHED: "Matched ✓", MISMATCHED: "Mismatch ⚠" };
const STATUS_CLASS = { PENDING: "dt-status-pending", MATCHED: "dt-status-matched", MISMATCHED: "dt-status-mismatched" };

export default function DealerTipPage() {
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem(AUTH_KEY) || "null"); } catch { return null; }
  });
  const [pin, setPin] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginErr, setLoginErr] = useState("");

  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);
  const showToast = useCallback((msg, err = false) => {
    setToast({ msg, err });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3200);
  }, []);

  const api = useCallback(
    async (method, path, data) => {
      const res = await axiosRequest(method, `${API_URL}${path}`, null, data, auth?.token ? { "dealer-token": auth.token } : {});
      const httpStatus = res?.response?.status;
      if (httpStatus === 401 || httpStatus === 403) {
        localStorage.removeItem(AUTH_KEY);
        setAuth(null);
        return { ok: false, error: "Session expired, please log in again" };
      }
      if (!res || !res.data) {
        return { ok: false, error: res?.response?.data?.error || res?.message || "Network error" };
      }
      return { ok: true, payload: res.data };
    },
    [auth]
  );

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return;
    setLoginLoading(true);
    setLoginErr("");
    const { ok, payload, error } = await api("post", "/dealer-tip/login", { pin: pin.trim() });
    setLoginLoading(false);
    if (!ok) return setLoginErr(error || "Login failed");
    if (!payload?.status) return setLoginErr(payload?.message || "Invalid PIN");
    const next = { token: payload.token, employee_name: payload.employee_name };
    localStorage.setItem(AUTH_KEY, JSON.stringify(next));
    setAuth(next);
  };

  const handleLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    setAuth(null);
    setPin("");
  };

  if (!auth?.token) {
    return (
      <div className="dt-root">
        <style>{CSS}</style>
        <div className="dt-login-wrap">
          <div className="dt-login-card">
            <h1>🎰 Tip Chip Declaration</h1>
            <p>Dealer entry — enter your personal PIN to continue</p>
            <form onSubmit={handleLogin}>
              <div className="dt-field">
                <label>PIN</label>
                <input className="dt-input" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Enter your PIN" autoFocus />
              </div>
              <button className="dt-btn dt-btn-primary" disabled={loginLoading} type="submit">
                {loginLoading ? "Checking..." : "Enter"}
              </button>
              {loginErr && <div className="dt-login-err">{loginErr}</div>}
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dt-root">
      <style>{CSS}</style>
      <header className="dt-header">
        <h1>🎰 Declare Tip Chips — {auth.employee_name}</h1>
        <button className="dt-logout" onClick={handleLogout}>Log out</button>
      </header>
      <div className="dt-body">
        <DeclareForm api={api} showToast={showToast} employeeName={auth.employee_name} />
      </div>
      {toast && <div className={`dt-toast${toast.err ? " err" : ""}`}>{toast.msg}</div>}
    </div>
  );
}

function DeclareForm({ api, showToast, employeeName }) {
  const [chips, setChips] = useState([]);
  const [saving, setSaving] = useState(false);
  const [myDeclarations, setMyDeclarations] = useState([]);

  useEffect(() => {
    api("get", "/dealer-tip/chip-denominations").then((res) => {
      if (res.ok) {
        const denoms = res.payload?.denominations || [];
        setChips(denoms.map((d) => ({ denomination: d, quantity: "" })));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMyDeclarations = useCallback(async () => {
    const { ok, payload } = await api("get", "/dealer-tip/declarations");
    if (ok) setMyDeclarations(payload?.entries || []);
  }, [api]);

  useEffect(() => { loadMyDeclarations(); }, [loadMyDeclarations]);

  const calcAmount = (denom, qty) => Number(denom || 0) * Number(qty || 0);
  const total = chips.reduce((sum, c) => sum + calcAmount(c.denomination, c.quantity), 0);

  const handleQtyChange = (index, value) => {
    const updated = [...chips];
    updated[index] = { ...updated[index], quantity: value };
    setChips(updated);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (total <= 0) return showToast("Enter at least one chip quantity", true);
    setSaving(true);
    const { ok, payload } = await api("post", "/dealer-tip/declarations", {
      chips: chips.filter((c) => Number(c.quantity) > 0).map((c) => ({ denomination: c.denomination, quantity: c.quantity })),
    });
    setSaving(false);
    if (!ok || !payload?.status) return showToast(payload?.message || "Could not submit declaration", true);
    showToast(`Declared ₹${total.toLocaleString()} — hand your chips to the cashier now`);
    setChips((cs) => cs.map((c) => ({ ...c, quantity: "" })));
    loadMyDeclarations();
  };

  return (
    <>
      <form onSubmit={submit}>
        <div className="dt-card">
          <div className="dt-field">
            <label>Your Name</label>
            <div className="dt-selected-name">
              <span>{employeeName}</span>
            </div>
          </div>
          <div className="dt-field">
            <label>Chips You're Handing Over</label>
            {chips.map((chip, i) => {
              const cc = getChipColor(chip.denomination);
              return (
                <div className="dt-chip-row" key={chip.denomination}>
                  <div className="dt-chip-badge" style={{ background: cc.bg, color: cc.text }}>{chip.denomination}</div>
                  <input
                    className="dt-input" type="number" min="0" inputMode="numeric" placeholder="Qty"
                    value={chip.quantity} onChange={(e) => handleQtyChange(i, e.target.value)}
                  />
                  <div className="dt-amount">{calcAmount(chip.denomination, chip.quantity) > 0 ? `₹${calcAmount(chip.denomination, chip.quantity).toLocaleString()}` : "—"}</div>
                </div>
              );
            })}
          </div>
          <div className={`dt-total${total <= 0 ? " zero" : ""}`}>Total: ₹{total.toLocaleString()}</div>
        </div>
        <button className="dt-btn dt-btn-primary" disabled={saving || !employeeName || total <= 0} type="submit">
          {saving ? "Submitting..." : "Submit Declaration"}
        </button>
        <p style={{ textAlign: "center", color: "#7d818c", fontSize: 12, marginTop: 10 }}>
          Submit this before handing chips to the cashier — it's what your handover gets checked against.
        </p>
      </form>

      {employeeName && (
        <div style={{ marginTop: 22 }}>
          <div className="dt-section-title">Your Recent Declarations</div>
          {!myDeclarations.length ? (
            <div className="dt-empty">No declarations yet.</div>
          ) : (
            myDeclarations.map((d) => (
              <div className="dt-decl-row" key={d._id}>
                <div className="dt-decl-info">
                  <div className="dt-decl-name">₹{(d.total_amount || 0).toLocaleString()}</div>
                  <div className="dt-decl-sub">{fmtTime(d.createdAt)}</div>
                </div>
                <span className={`dt-status ${STATUS_CLASS[d.status] || ""}`}>{STATUS_LABEL[d.status] || d.status}</span>
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
}
